import { formatDate } from '@/utils/index'
import eventHub from '@/utils/eventHub'
import env from '@/config/env'

// 农机预约
export const MACHINEAPPOINT = 'MACHINE_APPOINT'
// 农机交易
export const MACHINEJOB = 'MACHINE_JOB'
// 农机标点
export const MACHINEPOINT = 'MACHINE_POINT'

const { protocol } = window.location

export const uri =
    protocol === 'https:' ? `wss://${env.SOCKET_URL}` : `ws://${env.SOCKET_URL}`
export const uri2 =
    env.SOCKET_TYPE === 'stage'
        ? `wss://${env.SOCKET_URL2}`
        : `ws://${env.SOCKET_URL2}`

class Socket {
    instance = null
    loseNum = 0
    loseTime = ''
    enableReconnect = false
    reconnectionCount = 0
    timer = 0
    heartTimer = 0
    noticeInstance = false

    constructor() {
        // socket 实例
        this.instance = null
        // socket url
        this.url = uri
        // socket 断开次数
        this.loseNum = 1
        // socket 断开时间
        this.loseTime = formatDate()
        // 重连 socket 次数
        this.reconnectionCount = 0
        // 重连 timer
        this.timer = 0
        // 心跳 heartTimer
        this.heartTimer = 0
        // 是否允许 socket 重连
        this.enableReconnect = true
        // 当前是否存在离线提示
        this.noticeInstance = false

        this.inits = this.inits.bind(this)
        this.onopen = this.onopen.bind(this)
        this.onmessage = this.onmessage.bind(this)
        this.onclose = this.onclose.bind(this)
        this.onerror = this.onerror.bind(this)
    }

    // 初始化 socket
    inits(url) {
        if (this.instance) return
        this.url = url
        this.enableReconnect = true
        this.instance = new WebSocket(url)
        this.instance.onopen = this.onopen
        this.instance.onmessage = this.onmessage
        this.instance.onclose = this.onclose
        this.instance.onerror = this.onerror
    }
    // 打开连接
    onopen(ev) {
        const { reconnectionCount } = this
        if (!this.instance) console.log('socket 实例未初始化', this.instance)
        this.reconnectionCount = 0
        console.log('打开连接：', ev)
        this.heartStart()
        if (reconnectionCount) {
            // 重连次数为真, 说明是重连的, 需要通知用户
            this.openSuccessNotice()
            this.loseNum++
            this.noticeInstance = false
        }
    }
    // 接收信息
    onmessage(ev) {
        console.log('收到消息：', ev.data)
        try {
            const data = JSON.parse(ev.data)

            switch (data.type) {
                case MACHINEAPPOINT:
                    eventHub.$emit(MACHINEAPPOINT, data.data)
                    break
                case MACHINEJOB:
                    eventHub.$emit(MACHINEJOB, data.data)
                    break
                case MACHINEPOINT:
                    eventHub.$emit(MACHINEPOINT, data.data)
                    break
                default:
                    eventHub.$emit('setAmList', data)
                    break
            }
        } catch (error) {
            console.log('解析错误：', error, ev)
        }
    }
    // 关闭连接
    onclose(ev) {
        this.instance = null
        console.log('关闭连接：', ev)
        this.reconnect()
    }
    // 连接产生错误
    onerror(ev) {
        console.log('连接产生错误：', ev)
        this.instance && this.instance.close()
        this.instance = null
        this.reconnect()
    }
    /**
     * @description: 发送数据
     * @param {any} data: 发送的数据
     */
    send(data) {
        if (!this.instance) {
            console.info(
                'socket 服务关闭，正在尝试重连，重连地址为：',
                this.url
            )
            this.inits(this.url)
            return false
        }
        this.instance.send(JSON.stringify(data))
        return true
    }
    // 发送心跳
    heartStart() {
        this.heartEnd()
        this.heartTimer = window.setInterval(() => {
            if (!this.instance) return this.heartEnd()
            this.send('')
            console.log('ws 心跳检测')
        }, 25000)
    }
    // 停止发送心跳
    heartEnd() {
        clearInterval(this.heartTimer)
        this.heartTimer = 0
        console.log('停止 ws 心跳检测')
    }
    // socket 重连
    reconnect() {
        const { enableReconnect, noticeInstance } = this
        if (!enableReconnect) {
            return
        }
        if (!noticeInstance) {
            this.noticeInstance = true
            this.loseTime = formatDate()
            this.openFailNotice()
        }
        this.reconnectionCount++
        clearTimeout(this.timer)
        console.log('调用 socket 重连方法，socket 地址为：', this.url)
        this.timer = window.setTimeout(() => {
            this.inits(this.url)
        }, 5000)
    }
    // 打开失败提示窗口
    openFailNotice() {
        const { loseTime, loseNum } = this
        console.log('打开失败提示窗口', loseTime, loseNum)
    }
    // 打开成功提示窗口
    openSuccessNotice() {
        const { loseTime } = this
        console.log('打开成功提示窗口', loseTime)
    }
    // 销毁实例
    destroy() {
        this.instance && this.instance.close()
        this.heartEnd()
        // 因关闭事件中存在重连回调，清空重连事件，timer 也需实时获取
        clearTimeout(this.timer)
        this.instance = null
        this.loseNum = 1
        this.loseTime = ''
        this.enableReconnect = false
        this.noticeInstance = false
        this.reconnectionCount = 0
    }
}

export default new Socket()
